import React, { useState, useEffect } from 'react';
import { Card, Table, Form, Button, Badge } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useQuery, useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { HOPDONGCHITIET_API } from '../../../utils/apiUrl';
import { Get, Put, DeleteSingle } from '../../../utils/httpProvider';
import { objectShowNumber, messageToast, status200 } from '../../../utils/define';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ConfirmModal } from '../../../modules/modal/ConfirmModal';
import KhoaDaoTaoModal from './components/KhoaDaoTaoModal';

const KhoaDaoTao = () => {
    const valueSearch = useSelector((state) => state.search.valueSearch);
    const history = useHistory();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    // Modal Add/Edit states
    const [openModal, setOpenModal] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);

    // Delete Confirmation states
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [idToDelete, setIdToDelete] = useState('');
    const [deleteMessage, setDeleteMessage] = useState('');

    // --- FETCH COURSE DATA ---
    const { data: coursesData, isLoading, refetch } = useQuery(
        ['coursesListOnly', page, pageSize, valueSearch],
        () => Get(HOPDONGCHITIET_API.GET_PAGING, null, {
            pageIndex: page,
            pageSize: pageSize,
            keyword: valueSearch || ''
        }, false),
        { keepPreviousData: true }
    );

    // Fetch Trang thai options from Backend Enum API
    const { data: trangThaiOptionsData } = useQuery(
        ['trangThaiOptionsList'],
        () => Get(HOPDONGCHITIET_API.GET_TRANG_THAI_OPTIONS)
    );

    const statusOptions = trangThaiOptionsData?.$values || trangThaiOptionsData || [];

    // Mutation to update status inline
    const updateStatusMutation = useMutation(
        ({ id, status }) => Put(`${HOPDONGCHITIET_API.UPDATE_STATUS}/${id}?trangThai=${status}`),
        {
            onSuccess: () => {
                toast.success("Cập nhật trạng thái khóa đào tạo thành công!");
                refetch();
            },
            onError: (err) => {
                toast.error(err?.message || "Cập nhật trạng thái thất bại.");
            }
        }
    );

    // Delete Mutation
    const deleteCourseMutation = useMutation((id) => DeleteSingle(`${HOPDONGCHITIET_API.DELETE_ITEM}/${id}`));

    const handleDeleteClick = (id, name) => {
        setIdToDelete(id);
        setDeleteMessage(`Bạn có chắc chắn muốn xóa khóa đào tạo thực hành: "${name}"?`);
        setOpenDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (!idToDelete) return;
        deleteCourseMutation.mutate(idToDelete, {
            onSuccess: (res) => {
                if (res.status === status200 || res.status === 201 || res === true || res.id) {
                    toast.success(messageToast.messageToastDeleteSuccess);
                    refetch();
                } else {
                    toast.error(messageToast.messageToastDeleteError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra khi xóa.");
            }
        });
        setOpenDeleteModal(false);
        setIdToDelete('');
    };

    useEffect(() => {
        setPage(1);
    }, [valueSearch]);

    const courses = coursesData?.data?.$values || coursesData?.data || coursesData?.items?.$values || coursesData?.items || [];
    const totalRecords = coursesData?.totalRecords || 0;

    return (
        <div className="container-fluid p-4">
            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: '16px' }}>
                <Card.Body className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="font-weight-bold mb-0 text-primary">
                            <i className="fas fa-graduation-cap mr-2"></i>Quản lý Khóa đào tạo thực hành
                        </h4>
                        <Button
                            variant="success"
                            onClick={() => { setSelectedCourse(null); setOpenModal(true); }}
                            style={{ borderRadius: '8px' }}
                        >
                            <i className="fas fa-plus mr-1"></i>Thêm mới khóa đào tạo
                        </Button>
                    </div>

                    <div className="table-responsive">
                        <Table striped bordered hover className="align-middle" style={{ fontSize: '0.9rem' }}>
                            <thead className="thead-light">
                                <tr>
                                    <th style={{ width: '55px' }} className="text-center">STT</th>
                                    <th>Tên khóa học</th>
                                    <th>Đào tạo cho HDCT</th>
                                    <th>Đối tượng</th>
                                    <th>Chuyên ngành</th>
                                    <th>Đơn vị thực hành</th>
                                    <th className="text-center">Số học viên</th>
                                    <th className="text-center">Số giảng viên</th>
                                    <th style={{ width: '120px' }} className="text-center">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={9} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                ) : courses.length === 0 ? (
                                    <tr><td colSpan={9} className="text-center py-4 text-muted">Chưa có khóa đào tạo nào</td></tr>
                                ) : (
                                    courses.map((item, idx) => {
                                        const rawSchool = item.truongThucTapTen || item.TruongThucTapTen || item.hopDongNguyenTac?.truongThucTap?.tenTruong || item.hopDongNguyenTac?.truongThucTap?.TenTruong || '';
                                        const schoolName = (rawSchool === '-' || rawSchool === 'Chưa có') ? '' : rawSchool;

                                        const dateStart = (item.ngayKy || item.NgayKy) ? moment(item.ngayKy || item.NgayKy).format('DD/MM/YYYY') : '';
                                        const dateEnd = (item.ngayKetThuc || item.NgayKetThuc) ? moment(item.ngayKetThuc || item.NgayKetThuc).format('DD/MM/YYYY') : '';

                                        return (
                                            <tr key={item.id || item.Id}>
                                                <td className="text-center">{(page - 1) * pageSize + idx + 1}</td>
                                                <td>
                                                    <div className="font-weight-bold text-dark">{item.tenKhoaDaoTao}</div>
                                                    {dateStart && dateEnd && <small className="text-muted d-block mt-0.5">{dateStart} - {dateEnd}</small>}
                                                    <div className="mt-1" style={{ maxWidth: '180px' }}>
                                                        <Form.Control
                                                            as="select"
                                                            size="sm"
                                                            value={item.trangThai || item.TrangThai || 1}
                                                            onChange={(e) => updateStatusMutation.mutate({ id: item.id || item.Id, status: Number(e.target.value) })}
                                                            style={{
                                                                fontSize: '0.75rem',
                                                                fontWeight: 'bold',
                                                                textTransform: 'uppercase',
                                                                color:
                                                                    Number(item.trangThai || item.TrangThai) === 2 ? '#28a745' :
                                                                    Number(item.trangThai || item.TrangThai) === 3 ? '#007bff' :
                                                                    Number(item.trangThai || item.TrangThai) === 4 ? '#ffc107' :
                                                                    Number(item.trangThai || item.TrangThai) === 5 ? '#dc3545' : '#6c757d',
                                                                borderColor: 'transparent',
                                                                backgroundColor: 'rgba(0,0,0,0.03)',
                                                                cursor: 'pointer',
                                                                padding: '2px 5px',
                                                                height: 'auto'
                                                            }}
                                                        >
                                                            {statusOptions.map((opt) => (
                                                                <option key={opt.value || opt.Value} value={opt.value || opt.Value} style={{ color: '#333' }}>
                                                                    {opt.name || opt.Name}
                                                                </option>
                                                            ))}
                                                        </Form.Control>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="font-weight-bold text-secondary">
                                                        Số HĐ: {item.soHopDong || '-'}
                                                    </div>
                                                    {dateStart && <small className="text-muted d-block">Ngày ký HĐ: {dateStart}</small>}
                                                </td>
                                                <td>{(!item.doiTuong || item.doiTuong === '-' || item.doiTuong === 'Chưa có') ? '-' : item.doiTuong}</td>
                                                <td>
                                                    {item.nganhDaoTaoTen && item.chuongTrinhDaoTaoTen
                                                        ? `${item.nganhDaoTaoTen} - ${item.chuongTrinhDaoTaoTen}`
                                                        : (item.nganhDaoTaoTen || item.chuongTrinhDaoTaoTen || 'Chưa rõ')}
                                                </td>
                                                <td className="font-weight-bold text-secondary">{schoolName || '-'}</td>
                                                <td className="text-center font-weight-bold text-dark">
                                                    {item.soLuongHocVien || item.SoLuongHocVien || 0}
                                                </td>
                                                <td className="text-center font-weight-bold text-dark">
                                                    {item.soLuongGiangVien || item.SoLuongGiangVien || 0}
                                                </td>
                                                <td className="text-center">
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        className="p-1 mr-1 text-primary text-decoration-none"
                                                        onClick={() => history.push(`/khoa-dao-tao/detail/${item.id || item.Id}`)}
                                                        title="Xem chi tiết"
                                                    >
                                                        <i className="fas fa-eye"></i>
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        className="p-1 mr-1 text-warning text-decoration-none"
                                                        onClick={() => { setSelectedCourse(item); setOpenModal(true); }}
                                                        title="Sửa khóa đào tạo"
                                                    >
                                                        <i className="fas fa-edit"></i>
                                                    </Button>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        className="p-1 text-danger text-decoration-none"
                                                        onClick={() => handleDeleteClick(item.id || item.Id, item.tenKhoaDaoTao || item.TenKhoaDaoTao)}
                                                        title="Xóa khóa đào tạo"
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Form.Control
                            as="select"
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            style={{ width: '100px', borderRadius: '8px' }}
                        >
                            {objectShowNumber.map((opt) => (
                                <option key={opt.value} value={opt.value}>{opt.text}</option>
                            ))}
                        </Form.Control>
                        <Pagination
                            itemClass="page-item"
                            linkClass="page-link"
                            innerClass="pagination pagination-sm no-margin mb-0"
                            activePage={page}
                            itemsCountPerPage={pageSize}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={(num) => setPage(num)}
                        />
                    </div>
                </Card.Body>
            </Card>

            {/* Modals */}
            <KhoaDaoTaoModal
                isOpen={openModal}
                handleClose={() => { setOpenModal(false); setSelectedCourse(null); }}
                data={selectedCourse}
                refetch={refetch}
            />

            <ConfirmModal
                isOpen={openDeleteModal}
                handleClose={() => setOpenDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message={deleteMessage}
            />
        </div>
    );
};

export default KhoaDaoTao;
